import * as Yup from "yup";

export const initialValues = (data, occasions, themes, services, t) => {
  const occasionId = data?.occasion_type?.id ?? data?.occasion_id;
  const themeId = data?.theme?.id ?? data?.theme_id;
  const serviceIds =
    data?.services?.map((s) => s.id) ?? data?.service_ids ?? [];

  return {
    ...data,
    location_type: data?.location_type,
    environment: data?.environment,
    occasion_id: occasionId
      ? {
          label:
            occasions?.find((o) => o.id === occasionId)?.localized_data?.en
              ?.name ||
            data?.occasion_type?.localized_data?.en?.name ||
            data?.occasion_type?.name ||
            t("event_planning.occasion_fallback", { id: occasionId }),
          value: occasionId,
        }
      : null,
    attendees_max: data?.attendees_max,
    attendees_min: data?.attendees_min,
    event_date: data?.event_date,
    day_period: data?.day_period,
    budget: data?.budget,
    theme_id: themeId
      ? {
          label:
            themes?.find((th) => th.id === themeId)?.localized_data?.en?.name ||
            data?.theme?.localized_data?.en?.name ||
            data?.theme?.name ||
            t("event_planning.theme_fallback", { id: themeId }),
          value: themeId,
        }
      : null,
    service_ids: serviceIds.map((id) => {
      const service =
        services?.find((s) => s.id === id) ||
        data?.services?.find((s) => s.id === id);
      return {
        label:
          service?.localized_data?.en?.name ||
          service?.name ||
          t("event_planning.service_fallback", { id }),
        value: id,
      };
    }),
  };
};

export const structure = (occasions, themes, services, t) => [
  {
    head: t("event_planning.event_details"),
    width: "100%",
    list: [
      {
        name: "location_type",
        label: t("event_planning.location_type"),
        kind: "select",
        options: [
          { id: "user_provided", name: t("event_planning.user_provided") },
          { id: "suite", name: t("event_planning.suite") },
          { id: "hall", name: t("event_planning.hall") },
        ],
        width: "48%",
      },
      {
        name: "environment",
        label: t("event_planning.environment"),
        kind: "select",
        options: [
          { id: "indoor", name: t("event_planning.indoor") },
          { id: "outdoor", name: t("event_planning.outdoor") },
        ],
        width: "48%",
      },
      {
        name: "occasion_id",
        label: t("event_planning.occasion"),
        kind: "select",
        options: occasions?.map((item) => ({
          id: item.id,
          name: item.localized_data?.en?.name || item.name,
        })),
        width: "48%",
      },
      {
        name: "theme_id",
        label: t("event_planning.theme"),
        kind: "select",
        options: themes?.map((item) => ({
          id: item.id,
          name: item.localized_data?.en?.name || item.name,
        })),
        width: "48%",
      },
      {
        name: "attendees_min",
        kind: "input",
        type: "number",
        label: t("event_planning.min_attendees"),
        width: "48%",
      },
      {
        name: "attendees_max",
        kind: "input",
        type: "number",
        label: t("event_planning.max_attendees"),
        width: "48%",
      },
      {
        name: "event_date",
        kind: "input",
        type: "date",
        label: t("event_planning.event_date"),
        width: "48%",
      },
      {
        name: "day_period",
        label: t("event_planning.day_period"),
        kind: "select",
        options: [
          { id: "morning", name: t("event_planning.morning") },
          { id: "evening", name: t("event_planning.evening") },
        ],
        width: "48%",
      },
      {
        name: "budget",
        kind: "input",
        type: "number",
        label: t("event_planning.budget"),
        width: "48%",
      },
      {
        name: "service_ids",
        label: t("event_planning.services"),
        kind: "multiSelect", // Assuming multiSelect supports simple options or needs mapped structure
        options: services?.map((item) => ({
          id: item.id,
          name: item.localized_data?.en?.name || item.name,
        })),
        width: "48%",
      },
    ],
  },
];

export const validationSchema = (t) =>
  Yup.object({
    location_type: Yup.string().required(t("common.required")),
    environment: Yup.string().required(t("common.required")),
    occasion_id: Yup.mixed().required(t("common.required")),
    theme_id: Yup.mixed().required(t("common.required")),
    attendees_min: Yup.number().required(t("common.required")),
    attendees_max: Yup.number().required(t("common.required")),
    event_date: Yup.string().required(t("common.required")),
    day_period: Yup.string().required(t("common.required")),
    budget: Yup.number().required(t("common.required")),
  });
